module.exports = "/images/b856d714bf2bbe4a8e9436905475b66f.png";